import { useMutation } from '@tanstack/react-query';

import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';

export const useSaveBudgetItemComment = (commentType: 'excess' | 'purchase' = 'purchase') =>
    useMutation({
        mutationFn:
            commentType === 'purchase'
                ? ordersRecognitionApi.saveOrderComment
                : ordersRecognitionApi.saveExcessComment,
    });
